import React, { useState } from 'react';

import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Box, ModalFooter, Divider } from '@chakra-ui/react';
import useOneOnOnePageParams from 'screens/oneOnOneRabbit/hooks/useOneOnOnePageParams';

import { Cross } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium, TextHeader3 } from 'uiToolkitV1/Typography';

import { cancelOneOnOneMeeting } from '../../services';
import { StyleCloseButton } from './ArchiveMeetingModal';

interface Props {
  isOpen?: boolean;
  onClose?: () => void;
  onSave?: () => void;
}

const CancelMeetingModal = ({ isOpen, onClose, onSave }: Props) => {
  const [loading, setLoading] = useState(false);
  // const { startTime } = useOneOnOneInstanceDetails({
  //   masterId: 1,
  //   instanceId: 1
  // });

  const { masterId, instanceId } = useOneOnOnePageParams();

  const onMeetingCancel = async () => {
    try {
      setLoading(true);
      await cancelOneOnOneMeeting({
        masterId,
        instanceId,
      });
      onSave && onSave();
    } catch (error) {
      console.log('Error cancelling meeting : ', error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent position="relative" maxH="204px" maxW={isMobileView() ? '300px' : '578px'}>
        <ModalHeader position="relative">
          <TextHeader3 bold>Cancel Recurring Event</TextHeader3>
          <StyleCloseButton
            variant="filled"
            color="black"
            StartIcon={(props) => <Cross {...props} boxSize="20px" />}
            onClick={onClose}
          />
        </ModalHeader>
        <Divider opacity={1} color="#EBEFF3" />

        <ModalBody p="26px 30px">
          <Box display="flex">
            <TextBodyMedium>This meeting will be marked as skipped. Do you want to cancel this 1:1?</TextBodyMedium>
          </Box>
        </ModalBody>
        <ModalFooter
          sx={{
            background: '#F5F7F9',
            borderTop: '1px solid #CED7DF',
            borderRadius: '0px 0px 8px 8px',
          }}
        >
          <Button
            sx={{
              '&>p': {
                marginLeft: 0,
              },
            }}
            mr="auto"
            variant="tertiary"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button disabled={loading} onClick={onMeetingCancel}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export { CancelMeetingModal };
